// source: account.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var user_pb = require('./user_pb.js');
goog.object.extend(proto, user_pb);
var enums_pb = require('./enums_pb.js');
goog.object.extend(proto, enums_pb);
goog.exportSymbol('proto.cloud.Account', null, global);
goog.exportSymbol('proto.cloud.AccountRole', null, global);
goog.exportSymbol('proto.cloud.AccountUserSettings', null, global);
goog.exportSymbol('proto.cloud.Project', null, global);
goog.exportSymbol('proto.cloud.ProjectRole', null, global);
goog.exportSymbol('proto.cloud.ProjectRoleItem', null, global);
goog.exportSymbol('proto.cloud.ProjectRoleListItem', null, global);
goog.exportSymbol('proto.cloud.RoleDetails', null, global);
goog.exportSymbol('proto.cloud.UserRoleItem', null, global);
goog.exportSymbol('proto.cloud.UserRoleItem.Projects', null, global);
goog.exportSymbol('proto.cloud.UserRolePending', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.Project = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cloud.Project, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.Project.displayName = 'proto.cloud.Project';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.Account = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.cloud.Account.repeatedFields_, null);
};
goog.inherits(proto.cloud.Account, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.Account.displayName = 'proto.cloud.Account';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.AccountUserSettings = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cloud.AccountUserSettings, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.AccountUserSettings.displayName = 'proto.cloud.AccountUserSettings';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.RoleDetails = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.cloud.RoleDetails.repeatedFields_, null);
};
goog.inherits(proto.cloud.RoleDetails, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.RoleDetails.displayName = 'proto.cloud.RoleDetails';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.ProjectRole = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cloud.ProjectRole, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.ProjectRole.displayName = 'proto.cloud.ProjectRole';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.AccountRole = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cloud.AccountRole, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.AccountRole.displayName = 'proto.cloud.AccountRole';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.ProjectRoleListItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.cloud.ProjectRoleListItem.repeatedFields_, null);
};
goog.inherits(proto.cloud.ProjectRoleListItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.ProjectRoleListItem.displayName = 'proto.cloud.ProjectRoleListItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.ProjectRoleItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cloud.ProjectRoleItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.ProjectRoleItem.displayName = 'proto.cloud.ProjectRoleItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.UserRoleItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.cloud.UserRoleItem.repeatedFields_, null);
};
goog.inherits(proto.cloud.UserRoleItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.UserRoleItem.displayName = 'proto.cloud.UserRoleItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.UserRoleItem.Projects = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cloud.UserRoleItem.Projects, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.UserRoleItem.Projects.displayName = 'proto.cloud.UserRoleItem.Projects';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.UserRolePending = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.cloud.UserRolePending.repeatedFields_, null);
};
goog.inherits(proto.cloud.UserRolePending, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.UserRolePending.displayName = 'proto.cloud.UserRolePending';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.Project.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.Project.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.Project} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.Project.toObject = function(includeInstance, msg) {
  var f, obj = {
    projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    accountId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    name: jspb.Message.getFieldWithDefault(msg, 3, ""),
    icon: jspb.Message.getFieldWithDefault(msg, 4, ""),
    jobsCount: jspb.Message.getFieldWithDefault(msg, 5, 0),
    mediaCount: jspb.Message.getFieldWithDefault(msg, 6, 0),
    spaceUsed: jspb.Message.getFieldWithDefault(msg, 7, 0),
    totalFileCount: jspb.Message.getFieldWithDefault(msg, 8, 0),
    totalFolderCount: jspb.Message.getFieldWithDefault(msg, 9, 0),
    iconColor: jspb.Message.getFieldWithDefault(msg, 10, ""),
    dateCreated: jspb.Message.getFieldWithDefault(msg, 11, ""),
    dateModified: jspb.Message.getFieldWithDefault(msg, 12, ""),
    entitiesCount: jspb.Message.getFieldWithDefault(msg, 13, 0),
    resourceCount: jspb.Message.getFieldWithDefault(msg, 14, 0),
    resourceSize: jspb.Message.getFieldWithDefault(msg, 15, 0),
    reportCount: jspb.Message.getFieldWithDefault(msg, 16, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.Project}
 */
proto.cloud.Project.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.Project;
  return proto.cloud.Project.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.Project} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.Project}
 */
proto.cloud.Project.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setIcon(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setJobsCount(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMediaCount(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSpaceUsed(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotalFileCount(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotalFolderCount(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setIconColor(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setDateCreated(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setDateModified(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEntitiesCount(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setResourceCount(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setResourceSize(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setReportCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.Project.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.Project.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.Project} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.Project.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getIcon();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getJobsCount();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getMediaCount();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getSpaceUsed();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getTotalFileCount();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getTotalFolderCount();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getIconColor();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getDateCreated();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getDateModified();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getEntitiesCount();
  if (f !== 0) {
    writer.writeInt64(
      13,
      f
    );
  }
  f = message.getResourceCount();
  if (f !== 0) {
    writer.writeInt64(
      14,
      f
    );
  }
  f = message.getResourceSize();
  if (f !== 0) {
    writer.writeInt64(
      15,
      f
    );
  }
  f = message.getReportCount();
  if (f !== 0) {
    writer.writeInt64(
      16,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.cloud.Project.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.Project} returns this
 */
proto.cloud.Project.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string account_id = 2;
 * @return {string}
 */
proto.cloud.Project.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.Project} returns this
 */
proto.cloud.Project.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string name = 3;
 * @return {string}
 */
proto.cloud.Project.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.Project} returns this
 */
proto.cloud.Project.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string icon = 4;
 * @return {string}
 */
proto.cloud.Project.prototype.getIcon = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.Project} returns this
 */
proto.cloud.Project.prototype.setIcon = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int64 jobs_count = 5;
 * @return {number}
 */
proto.cloud.Project.prototype.getJobsCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.cloud.Project} returns this
 */
proto.cloud.Project.prototype.setJobsCount = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 media_count = 6;
 * @return {number}
 */
proto.cloud.Project.prototype.getMediaCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.cloud.Project} returns this
 */
proto.cloud.Project.prototype.setMediaCount = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 space_used = 7;
 * @return {number}
 */
proto.cloud.Project.prototype.getSpaceUsed = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.cloud.Project} returns this
 */
proto.cloud.Project.prototype.setSpaceUsed = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int64 total_file_count = 8;
 * @return {number}
 */
proto.cloud.Project.prototype.getTotalFileCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.cloud.Project} returns this
 */
proto.cloud.Project.prototype.setTotalFileCount = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int64 total_folder_count = 9;
 * @return {number}
 */
proto.cloud.Project.prototype.getTotalFolderCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.cloud.Project} returns this
 */
proto.cloud.Project.prototype.setTotalFolderCount = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional string icon_color = 10;
 * @return {string}
 */
proto.cloud.Project.prototype.getIconColor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.Project} returns this
 */
proto.cloud.Project.prototype.setIconColor = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string date_created = 11;
 * @return {string}
 */
proto.cloud.Project.prototype.getDateCreated = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.Project} returns this
 */
proto.cloud.Project.prototype.setDateCreated = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string date_modified = 12;
 * @return {string}
 */
proto.cloud.Project.prototype.getDateModified = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.Project} returns this
 */
proto.cloud.Project.prototype.setDateModified = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional int64 entities_count = 13;
 * @return {number}
 */
proto.cloud.Project.prototype.getEntitiesCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.cloud.Project} returns this
 */
proto.cloud.Project.prototype.setEntitiesCount = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional int64 resource_count = 14;
 * @return {number}
 */
proto.cloud.Project.prototype.getResourceCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.cloud.Project} returns this
 */
proto.cloud.Project.prototype.setResourceCount = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional int64 resource_size = 15;
 * @return {number}
 */
proto.cloud.Project.prototype.getResourceSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.cloud.Project} returns this
 */
proto.cloud.Project.prototype.setResourceSize = function(value) {
  return jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional int64 report_count = 16;
 * @return {number}
 */
proto.cloud.Project.prototype.getReportCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {number} value
 * @return {!proto.cloud.Project} returns this
 */
proto.cloud.Project.prototype.setReportCount = function(value) {
  return jspb.Message.setProto3IntField(this, 16, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.cloud.Account.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.Account.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.Account.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.Account} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.Account.toObject = function(includeInstance, msg) {
  var f, obj = {
    accountId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    projectsList: jspb.Message.toObjectList(msg.getProjectsList(),
    proto.cloud.Project.toObject, includeInstance),
    isHidden: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.Account}
 */
proto.cloud.Account.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.Account;
  return proto.cloud.Account.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.Account} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.Account}
 */
proto.cloud.Account.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = new proto.cloud.Project;
      reader.readMessage(value,proto.cloud.Project.deserializeBinaryFromReader);
      msg.addProjects(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsHidden(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.Account.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.Account.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.Account} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.Account.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getProjectsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.cloud.Project.serializeBinaryToWriter
    );
  }
  f = message.getIsHidden();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional string account_id = 1;
 * @return {string}
 */
proto.cloud.Account.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.Account} returns this
 */
proto.cloud.Account.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.cloud.Account.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.Account} returns this
 */
proto.cloud.Account.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated Project projects = 3;
 * @return {!Array<!proto.cloud.Project>}
 */
proto.cloud.Account.prototype.getProjectsList = function() {
  return /** @type{!Array<!proto.cloud.Project>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.cloud.Project, 3));
};


/**
 * @param {!Array<!proto.cloud.Project>} value
 * @return {!proto.cloud.Account} returns this
*/
proto.cloud.Account.prototype.setProjectsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.cloud.Project=} opt_value
 * @param {number=} opt_index
 * @return {!proto.cloud.Project}
 */
proto.cloud.Account.prototype.addProjects = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.cloud.Project, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.cloud.Account} returns this
 */
proto.cloud.Account.prototype.clearProjectsList = function() {
  return this.setProjectsList([]);
};


/**
 * optional bool is_hidden = 4;
 * @return {boolean}
 */
proto.cloud.Account.prototype.getIsHidden = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud.Account} returns this
 */
proto.cloud.Account.prototype.setIsHidden = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.AccountUserSettings.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.AccountUserSettings.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.AccountUserSettings} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.AccountUserSettings.toObject = function(includeInstance, msg) {
  var f, obj = {
    projectId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    notifyEvents: jspb.Message.getFieldWithDefault(msg, 4, 0),
    notifyByEmail: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    notifyOnlyPersonal: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
    notifyBySms: jspb.Message.getBooleanFieldWithDefault(msg, 7, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.AccountUserSettings}
 */
proto.cloud.AccountUserSettings.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.AccountUserSettings;
  return proto.cloud.AccountUserSettings.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.AccountUserSettings} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.AccountUserSettings}
 */
proto.cloud.AccountUserSettings.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 4:
      var value = /** @type {!proto.cloud.EventsToNotifyOn} */ (reader.readEnum());
      msg.setNotifyEvents(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setNotifyByEmail(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setNotifyOnlyPersonal(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setNotifyBySms(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.AccountUserSettings.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.AccountUserSettings.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.AccountUserSettings} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.AccountUserSettings.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getNotifyEvents();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getNotifyByEmail();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getNotifyOnlyPersonal();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getNotifyBySms();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
};


/**
 * optional string project_id = 3;
 * @return {string}
 */
proto.cloud.AccountUserSettings.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.AccountUserSettings} returns this
 */
proto.cloud.AccountUserSettings.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional EventsToNotifyOn notify_events = 4;
 * @return {!proto.cloud.EventsToNotifyOn}
 */
proto.cloud.AccountUserSettings.prototype.getNotifyEvents = function() {
  return /** @type {!proto.cloud.EventsToNotifyOn} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.cloud.EventsToNotifyOn} value
 * @return {!proto.cloud.AccountUserSettings} returns this
 */
proto.cloud.AccountUserSettings.prototype.setNotifyEvents = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional bool notify_by_email = 5;
 * @return {boolean}
 */
proto.cloud.AccountUserSettings.prototype.getNotifyByEmail = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud.AccountUserSettings} returns this
 */
proto.cloud.AccountUserSettings.prototype.setNotifyByEmail = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional bool notify_only_personal = 6;
 * @return {boolean}
 */
proto.cloud.AccountUserSettings.prototype.getNotifyOnlyPersonal = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud.AccountUserSettings} returns this
 */
proto.cloud.AccountUserSettings.prototype.setNotifyOnlyPersonal = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional bool notify_by_sms = 7;
 * @return {boolean}
 */
proto.cloud.AccountUserSettings.prototype.getNotifyBySms = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud.AccountUserSettings} returns this
 */
proto.cloud.AccountUserSettings.prototype.setNotifyBySms = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.cloud.RoleDetails.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.RoleDetails.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.RoleDetails.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.RoleDetails} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.RoleDetails.toObject = function(includeInstance, msg) {
  var f, obj = {
    description: jspb.Message.getFieldWithDefault(msg, 2, ""),
    name: jspb.Message.getFieldWithDefault(msg, 3, ""),
    permissionsList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f,
    mayCreateProject: jspb.Message.getBooleanFieldWithDefault(msg, 16, false),
    mayDeleteProject: jspb.Message.getBooleanFieldWithDefault(msg, 17, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.RoleDetails}
 */
proto.cloud.RoleDetails.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.RoleDetails;
  return proto.cloud.RoleDetails.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.RoleDetails} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.RoleDetails}
 */
proto.cloud.RoleDetails.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.addPermissions(value);
      break;
    case 16:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMayCreateProject(value);
      break;
    case 17:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMayDeleteProject(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.RoleDetails.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.RoleDetails.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.RoleDetails} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.RoleDetails.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPermissionsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
  f = message.getMayCreateProject();
  if (f) {
    writer.writeBool(
      16,
      f
    );
  }
  f = message.getMayDeleteProject();
  if (f) {
    writer.writeBool(
      17,
      f
    );
  }
};


/**
 * optional string description = 2;
 * @return {string}
 */
proto.cloud.RoleDetails.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.RoleDetails} returns this
 */
proto.cloud.RoleDetails.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string name = 3;
 * @return {string}
 */
proto.cloud.RoleDetails.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.RoleDetails} returns this
 */
proto.cloud.RoleDetails.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated string permissions = 4;
 * @return {!Array<string>}
 */
proto.cloud.RoleDetails.prototype.getPermissionsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.cloud.RoleDetails} returns this
 */
proto.cloud.RoleDetails.prototype.setPermissionsList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.cloud.RoleDetails} returns this
 */
proto.cloud.RoleDetails.prototype.addPermissions = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.cloud.RoleDetails} returns this
 */
proto.cloud.RoleDetails.prototype.clearPermissionsList = function() {
  return this.setPermissionsList([]);
};


/**
 * optional bool may_create_project = 16;
 * @return {boolean}
 */
proto.cloud.RoleDetails.prototype.getMayCreateProject = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 16, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud.RoleDetails} returns this
 */
proto.cloud.RoleDetails.prototype.setMayCreateProject = function(value) {
  return jspb.Message.setProto3BooleanField(this, 16, value);
};


/**
 * optional bool may_delete_project = 17;
 * @return {boolean}
 */
proto.cloud.RoleDetails.prototype.getMayDeleteProject = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 17, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud.RoleDetails} returns this
 */
proto.cloud.RoleDetails.prototype.setMayDeleteProject = function(value) {
  return jspb.Message.setProto3BooleanField(this, 17, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.ProjectRole.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.ProjectRole.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.ProjectRole} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.ProjectRole.toObject = function(includeInstance, msg) {
  var f, obj = {
    roleId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    accountId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    details: (f = msg.getDetails()) && proto.cloud.RoleDetails.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.ProjectRole}
 */
proto.cloud.ProjectRole.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.ProjectRole;
  return proto.cloud.ProjectRole.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.ProjectRole} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.ProjectRole}
 */
proto.cloud.ProjectRole.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRoleId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 4:
      var value = new proto.cloud.RoleDetails;
      reader.readMessage(value,proto.cloud.RoleDetails.deserializeBinaryFromReader);
      msg.setDetails(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.ProjectRole.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.ProjectRole.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.ProjectRole} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.ProjectRole.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRoleId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDetails();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.cloud.RoleDetails.serializeBinaryToWriter
    );
  }
};


/**
 * optional int64 role_id = 1;
 * @return {number}
 */
proto.cloud.ProjectRole.prototype.getRoleId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.cloud.ProjectRole} returns this
 */
proto.cloud.ProjectRole.prototype.setRoleId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string account_id = 2;
 * @return {string}
 */
proto.cloud.ProjectRole.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.ProjectRole} returns this
 */
proto.cloud.ProjectRole.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional RoleDetails details = 4;
 * @return {?proto.cloud.RoleDetails}
 */
proto.cloud.ProjectRole.prototype.getDetails = function() {
  return /** @type{?proto.cloud.RoleDetails} */ (
    jspb.Message.getWrapperField(this, proto.cloud.RoleDetails, 4));
};


/**
 * @param {?proto.cloud.RoleDetails|undefined} value
 * @return {!proto.cloud.ProjectRole} returns this
*/
proto.cloud.ProjectRole.prototype.setDetails = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud.ProjectRole} returns this
 */
proto.cloud.ProjectRole.prototype.clearDetails = function() {
  return this.setDetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.ProjectRole.prototype.hasDetails = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.AccountRole.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.AccountRole.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.AccountRole} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.AccountRole.toObject = function(includeInstance, msg) {
  var f, obj = {
    roleId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    accountId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    details: (f = msg.getDetails()) && proto.cloud.RoleDetails.toObject(includeInstance, f),
    inheritedProjectRole: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.AccountRole}
 */
proto.cloud.AccountRole.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.AccountRole;
  return proto.cloud.AccountRole.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.AccountRole} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.AccountRole}
 */
proto.cloud.AccountRole.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRoleId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 3:
      var value = new proto.cloud.RoleDetails;
      reader.readMessage(value,proto.cloud.RoleDetails.deserializeBinaryFromReader);
      msg.setDetails(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setInheritedProjectRole(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.AccountRole.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.AccountRole.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.AccountRole} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.AccountRole.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRoleId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDetails();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.cloud.RoleDetails.serializeBinaryToWriter
    );
  }
  f = message.getInheritedProjectRole();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * optional int64 role_id = 1;
 * @return {number}
 */
proto.cloud.AccountRole.prototype.getRoleId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.cloud.AccountRole} returns this
 */
proto.cloud.AccountRole.prototype.setRoleId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string account_id = 2;
 * @return {string}
 */
proto.cloud.AccountRole.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.AccountRole} returns this
 */
proto.cloud.AccountRole.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional RoleDetails details = 3;
 * @return {?proto.cloud.RoleDetails}
 */
proto.cloud.AccountRole.prototype.getDetails = function() {
  return /** @type{?proto.cloud.RoleDetails} */ (
    jspb.Message.getWrapperField(this, proto.cloud.RoleDetails, 3));
};


/**
 * @param {?proto.cloud.RoleDetails|undefined} value
 * @return {!proto.cloud.AccountRole} returns this
*/
proto.cloud.AccountRole.prototype.setDetails = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud.AccountRole} returns this
 */
proto.cloud.AccountRole.prototype.clearDetails = function() {
  return this.setDetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.AccountRole.prototype.hasDetails = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional int64 inherited_project_role = 4;
 * @return {number}
 */
proto.cloud.AccountRole.prototype.getInheritedProjectRole = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.cloud.AccountRole} returns this
 */
proto.cloud.AccountRole.prototype.setInheritedProjectRole = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.cloud.ProjectRoleListItem.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.ProjectRoleListItem.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.ProjectRoleListItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.ProjectRoleListItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.ProjectRoleListItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    project: (f = msg.getProject()) && proto.cloud.Project.toObject(includeInstance, f),
    newUserRolesAllowedList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.ProjectRoleListItem}
 */
proto.cloud.ProjectRoleListItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.ProjectRoleListItem;
  return proto.cloud.ProjectRoleListItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.ProjectRoleListItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.ProjectRoleListItem}
 */
proto.cloud.ProjectRoleListItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.cloud.Project;
      reader.readMessage(value,proto.cloud.Project.deserializeBinaryFromReader);
      msg.setProject(value);
      break;
    case 2:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt64());
      msg.setNewUserRolesAllowedList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.ProjectRoleListItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.ProjectRoleListItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.ProjectRoleListItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.ProjectRoleListItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProject();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.cloud.Project.serializeBinaryToWriter
    );
  }
  f = message.getNewUserRolesAllowedList();
  if (f.length > 0) {
    writer.writePackedInt64(
      2,
      f
    );
  }
};


/**
 * optional Project project = 1;
 * @return {?proto.cloud.Project}
 */
proto.cloud.ProjectRoleListItem.prototype.getProject = function() {
  return /** @type{?proto.cloud.Project} */ (
    jspb.Message.getWrapperField(this, proto.cloud.Project, 1));
};


/**
 * @param {?proto.cloud.Project|undefined} value
 * @return {!proto.cloud.ProjectRoleListItem} returns this
*/
proto.cloud.ProjectRoleListItem.prototype.setProject = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud.ProjectRoleListItem} returns this
 */
proto.cloud.ProjectRoleListItem.prototype.clearProject = function() {
  return this.setProject(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.ProjectRoleListItem.prototype.hasProject = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated int64 new_user_roles_allowed = 2;
 * @return {!Array<number>}
 */
proto.cloud.ProjectRoleListItem.prototype.getNewUserRolesAllowedList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.cloud.ProjectRoleListItem} returns this
 */
proto.cloud.ProjectRoleListItem.prototype.setNewUserRolesAllowedList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.cloud.ProjectRoleListItem} returns this
 */
proto.cloud.ProjectRoleListItem.prototype.addNewUserRolesAllowed = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.cloud.ProjectRoleListItem} returns this
 */
proto.cloud.ProjectRoleListItem.prototype.clearNewUserRolesAllowedList = function() {
  return this.setNewUserRolesAllowedList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.ProjectRoleItem.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.ProjectRoleItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.ProjectRoleItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.ProjectRoleItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    projectRole: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.ProjectRoleItem}
 */
proto.cloud.ProjectRoleItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.ProjectRoleItem;
  return proto.cloud.ProjectRoleItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.ProjectRoleItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.ProjectRoleItem}
 */
proto.cloud.ProjectRoleItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setProjectRole(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.ProjectRoleItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.ProjectRoleItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.ProjectRoleItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.ProjectRoleItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getProjectRole();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.cloud.ProjectRoleItem.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.ProjectRoleItem} returns this
 */
proto.cloud.ProjectRoleItem.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 project_role = 2;
 * @return {number}
 */
proto.cloud.ProjectRoleItem.prototype.getProjectRole = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.cloud.ProjectRoleItem} returns this
 */
proto.cloud.ProjectRoleItem.prototype.setProjectRole = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.cloud.UserRoleItem.repeatedFields_ = [4,7,8];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.UserRoleItem.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.UserRoleItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.UserRoleItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.UserRoleItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    user: (f = msg.getUser()) && user_pb.UserInfoBasic.toObject(includeInstance, f),
    accountId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    accountRoleId: jspb.Message.getFieldWithDefault(msg, 3, 0),
    explicitProjectRolesList: jspb.Message.toObjectList(msg.getExplicitProjectRolesList(),
    proto.cloud.UserRoleItem.Projects.toObject, includeInstance),
    mayRemoveFromAccount: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    assignableAccountRolesList: (f = jspb.Message.getRepeatedField(msg, 7)) == null ? undefined : f,
    assignableProjectRolesList: (f = jspb.Message.getRepeatedField(msg, 8)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.UserRoleItem}
 */
proto.cloud.UserRoleItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.UserRoleItem;
  return proto.cloud.UserRoleItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.UserRoleItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.UserRoleItem}
 */
proto.cloud.UserRoleItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new user_pb.UserInfoBasic;
      reader.readMessage(value,user_pb.UserInfoBasic.deserializeBinaryFromReader);
      msg.setUser(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAccountRoleId(value);
      break;
    case 4:
      var value = new proto.cloud.UserRoleItem.Projects;
      reader.readMessage(value,proto.cloud.UserRoleItem.Projects.deserializeBinaryFromReader);
      msg.addExplicitProjectRoles(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMayRemoveFromAccount(value);
      break;
    case 7:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt64());
      msg.setAssignableAccountRolesList(value);
      break;
    case 8:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt64());
      msg.setAssignableProjectRolesList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.UserRoleItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.UserRoleItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.UserRoleItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.UserRoleItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUser();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      user_pb.UserInfoBasic.serializeBinaryToWriter
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAccountRoleId();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getExplicitProjectRolesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.cloud.UserRoleItem.Projects.serializeBinaryToWriter
    );
  }
  f = message.getMayRemoveFromAccount();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getAssignableAccountRolesList();
  if (f.length > 0) {
    writer.writePackedInt64(
      7,
      f
    );
  }
  f = message.getAssignableProjectRolesList();
  if (f.length > 0) {
    writer.writePackedInt64(
      8,
      f
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.UserRoleItem.Projects.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.UserRoleItem.Projects.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.UserRoleItem.Projects} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.UserRoleItem.Projects.toObject = function(includeInstance, msg) {
  var f, obj = {
    projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    projectRole: jspb.Message.getFieldWithDefault(msg, 2, 0),
    canBeRemoved: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    mayBeModified: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.UserRoleItem.Projects}
 */
proto.cloud.UserRoleItem.Projects.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.UserRoleItem.Projects;
  return proto.cloud.UserRoleItem.Projects.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.UserRoleItem.Projects} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.UserRoleItem.Projects}
 */
proto.cloud.UserRoleItem.Projects.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setProjectRole(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCanBeRemoved(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMayBeModified(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.UserRoleItem.Projects.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.UserRoleItem.Projects.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.UserRoleItem.Projects} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.UserRoleItem.Projects.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getProjectRole();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getCanBeRemoved();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getMayBeModified();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.cloud.UserRoleItem.Projects.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.UserRoleItem.Projects} returns this
 */
proto.cloud.UserRoleItem.Projects.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 project_role = 2;
 * @return {number}
 */
proto.cloud.UserRoleItem.Projects.prototype.getProjectRole = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.cloud.UserRoleItem.Projects} returns this
 */
proto.cloud.UserRoleItem.Projects.prototype.setProjectRole = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional bool can_be_removed = 3;
 * @return {boolean}
 */
proto.cloud.UserRoleItem.Projects.prototype.getCanBeRemoved = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud.UserRoleItem.Projects} returns this
 */
proto.cloud.UserRoleItem.Projects.prototype.setCanBeRemoved = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional bool may_be_modified = 4;
 * @return {boolean}
 */
proto.cloud.UserRoleItem.Projects.prototype.getMayBeModified = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud.UserRoleItem.Projects} returns this
 */
proto.cloud.UserRoleItem.Projects.prototype.setMayBeModified = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional UserInfoBasic user = 1;
 * @return {?proto.cloud.UserInfoBasic}
 */
proto.cloud.UserRoleItem.prototype.getUser = function() {
  return /** @type{?proto.cloud.UserInfoBasic} */ (
    jspb.Message.getWrapperField(this, user_pb.UserInfoBasic, 1));
};


/**
 * @param {?proto.cloud.UserInfoBasic|undefined} value
 * @return {!proto.cloud.UserRoleItem} returns this
*/
proto.cloud.UserRoleItem.prototype.setUser = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud.UserRoleItem} returns this
 */
proto.cloud.UserRoleItem.prototype.clearUser = function() {
  return this.setUser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.UserRoleItem.prototype.hasUser = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string account_id = 2;
 * @return {string}
 */
proto.cloud.UserRoleItem.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.UserRoleItem} returns this
 */
proto.cloud.UserRoleItem.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 account_role_id = 3;
 * @return {number}
 */
proto.cloud.UserRoleItem.prototype.getAccountRoleId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.cloud.UserRoleItem} returns this
 */
proto.cloud.UserRoleItem.prototype.setAccountRoleId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * repeated Projects explicit_project_roles = 4;
 * @return {!Array<!proto.cloud.UserRoleItem.Projects>}
 */
proto.cloud.UserRoleItem.prototype.getExplicitProjectRolesList = function() {
  return /** @type{!Array<!proto.cloud.UserRoleItem.Projects>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.cloud.UserRoleItem.Projects, 4));
};


/**
 * @param {!Array<!proto.cloud.UserRoleItem.Projects>} value
 * @return {!proto.cloud.UserRoleItem} returns this
*/
proto.cloud.UserRoleItem.prototype.setExplicitProjectRolesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.cloud.UserRoleItem.Projects=} opt_value
 * @param {number=} opt_index
 * @return {!proto.cloud.UserRoleItem.Projects}
 */
proto.cloud.UserRoleItem.prototype.addExplicitProjectRoles = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.cloud.UserRoleItem.Projects, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.cloud.UserRoleItem} returns this
 */
proto.cloud.UserRoleItem.prototype.clearExplicitProjectRolesList = function() {
  return this.setExplicitProjectRolesList([]);
};


/**
 * optional bool may_remove_from_account = 5;
 * @return {boolean}
 */
proto.cloud.UserRoleItem.prototype.getMayRemoveFromAccount = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud.UserRoleItem} returns this
 */
proto.cloud.UserRoleItem.prototype.setMayRemoveFromAccount = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * repeated int64 assignable_account_roles = 7;
 * @return {!Array<number>}
 */
proto.cloud.UserRoleItem.prototype.getAssignableAccountRolesList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 7));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.cloud.UserRoleItem} returns this
 */
proto.cloud.UserRoleItem.prototype.setAssignableAccountRolesList = function(value) {
  return jspb.Message.setField(this, 7, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.cloud.UserRoleItem} returns this
 */
proto.cloud.UserRoleItem.prototype.addAssignableAccountRoles = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 7, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.cloud.UserRoleItem} returns this
 */
proto.cloud.UserRoleItem.prototype.clearAssignableAccountRolesList = function() {
  return this.setAssignableAccountRolesList([]);
};


/**
 * repeated int64 assignable_project_roles = 8;
 * @return {!Array<number>}
 */
proto.cloud.UserRoleItem.prototype.getAssignableProjectRolesList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 8));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.cloud.UserRoleItem} returns this
 */
proto.cloud.UserRoleItem.prototype.setAssignableProjectRolesList = function(value) {
  return jspb.Message.setField(this, 8, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.cloud.UserRoleItem} returns this
 */
proto.cloud.UserRoleItem.prototype.addAssignableProjectRoles = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 8, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.cloud.UserRoleItem} returns this
 */
proto.cloud.UserRoleItem.prototype.clearAssignableProjectRolesList = function() {
  return this.setAssignableProjectRolesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.cloud.UserRolePending.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.UserRolePending.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.UserRolePending.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.UserRolePending} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.UserRolePending.toObject = function(includeInstance, msg) {
  var f, obj = {
    email: jspb.Message.getFieldWithDefault(msg, 1, ""),
    userWhoAuthorized: jspb.Message.getFieldWithDefault(msg, 2, ""),
    accountRole: jspb.Message.getFieldWithDefault(msg, 3, 0),
    projectRolesList: jspb.Message.toObjectList(msg.getProjectRolesList(),
    proto.cloud.ProjectRoleItem.toObject, includeInstance),
    inviteId: jspb.Message.getFieldWithDefault(msg, 5, ""),
    creationDate: jspb.Message.getFieldWithDefault(msg, 6, ""),
    expirationDate: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.UserRolePending}
 */
proto.cloud.UserRolePending.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.UserRolePending;
  return proto.cloud.UserRolePending.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.UserRolePending} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.UserRolePending}
 */
proto.cloud.UserRolePending.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserWhoAuthorized(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAccountRole(value);
      break;
    case 4:
      var value = new proto.cloud.ProjectRoleItem;
      reader.readMessage(value,proto.cloud.ProjectRoleItem.deserializeBinaryFromReader);
      msg.addProjectRoles(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setInviteId(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreationDate(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setExpirationDate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.UserRolePending.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.UserRolePending.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.UserRolePending} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.UserRolePending.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserWhoAuthorized();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAccountRole();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getProjectRolesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.cloud.ProjectRoleItem.serializeBinaryToWriter
    );
  }
  f = message.getInviteId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCreationDate();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getExpirationDate();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional string email = 1;
 * @return {string}
 */
proto.cloud.UserRolePending.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.UserRolePending} returns this
 */
proto.cloud.UserRolePending.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string user_who_authorized = 2;
 * @return {string}
 */
proto.cloud.UserRolePending.prototype.getUserWhoAuthorized = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.UserRolePending} returns this
 */
proto.cloud.UserRolePending.prototype.setUserWhoAuthorized = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 account_role = 3;
 * @return {number}
 */
proto.cloud.UserRolePending.prototype.getAccountRole = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.cloud.UserRolePending} returns this
 */
proto.cloud.UserRolePending.prototype.setAccountRole = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * repeated ProjectRoleItem project_roles = 4;
 * @return {!Array<!proto.cloud.ProjectRoleItem>}
 */
proto.cloud.UserRolePending.prototype.getProjectRolesList = function() {
  return /** @type{!Array<!proto.cloud.ProjectRoleItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.cloud.ProjectRoleItem, 4));
};


/**
 * @param {!Array<!proto.cloud.ProjectRoleItem>} value
 * @return {!proto.cloud.UserRolePending} returns this
*/
proto.cloud.UserRolePending.prototype.setProjectRolesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.cloud.ProjectRoleItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.cloud.ProjectRoleItem}
 */
proto.cloud.UserRolePending.prototype.addProjectRoles = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.cloud.ProjectRoleItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.cloud.UserRolePending} returns this
 */
proto.cloud.UserRolePending.prototype.clearProjectRolesList = function() {
  return this.setProjectRolesList([]);
};


/**
 * optional string invite_id = 5;
 * @return {string}
 */
proto.cloud.UserRolePending.prototype.getInviteId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.UserRolePending} returns this
 */
proto.cloud.UserRolePending.prototype.setInviteId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string creation_date = 6;
 * @return {string}
 */
proto.cloud.UserRolePending.prototype.getCreationDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.UserRolePending} returns this
 */
proto.cloud.UserRolePending.prototype.setCreationDate = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string expiration_date = 7;
 * @return {string}
 */
proto.cloud.UserRolePending.prototype.getExpirationDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.UserRolePending} returns this
 */
proto.cloud.UserRolePending.prototype.setExpirationDate = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


goog.object.extend(exports, proto.cloud);
